"use strict";
// Make sure all of these are lower case;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RmtId = void 0;
var RmtId;
(function (RmtId) {
    RmtId["AMAZON"] = "amazon";
    RmtId["DELIVERR"] = "deliverr";
    RmtId["LOOP"] = "loop";
    RmtId["NARVAR"] = "narvar";
    RmtId["PARCEL"] = "parcel";
    RmtId["RETURNGO"] = "returngo";
    // @deprecated
    RmtId["BLIND"] = "Blind";
    RmtId["RETURNLY"] = "returnly";
    RmtId["SFN"] = "sfn";
    RmtId["SHOPIFY"] = "shopify";
})(RmtId || (exports.RmtId = RmtId = {}));
//# sourceMappingURL=RmtId.js.map